<div class="count-card">
    <div class="header">
        <h3 class="heading-tertiary">
            Inventories
        </h3>
    </div>
    <hr>



    <div class="counts">
        <div class="total-counts">
            <div class="total-count-child ">
                <a [routerLink]="['/hoardings']" title="Go to Inventory">
                    {{inventoryCount?.total}}
                </a>
            </div>
        </div>
        <div class="individual-count">
            <table>
                <tr>
                    <td class="detail-text">Units</td>
                    <td class="detail-count">{{inventoryCount?.unitTotal}}</td>
                </tr>
                <tr>
                    <td class="detail-text">Groups</td>
                    <td class="detail-count">{{inventoryCount?.grouppedTotal}}</td>
                </tr>
                <tr>
                    <td class="detail-text">Total Sqft</td>
                    <td class="detail-count">{{totalInventorySqft}}</td>
                </tr>
            </table>
        </div>
    </div>
</div>